import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { getPodsState } from '../../../features/pod/get_pods';

const PodsList = ({ route }) => {
    const getPods = useSelector(getPodsState);
    const navigate = useNavigate();

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell>Partner</TableCell>
                        <TableCell>Urządzenie</TableCell>
                        <TableCell>Opis</TableCell>
                        <TableCell>Adres</TableCell>
                        <TableCell align="center">Typ</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { getPods?.data?.content?.map(pod => (
                        <TableRow
                            key={ pod?.id }
                            hover
                            sx={ { cursor: 'pointer' } }
                            onClick={ () => navigate(route(pod?.id)) }
                        >
                            <TableCell>
                                { pod?.indoorPartner?.name }
                            </TableCell>
                            <TableCell>
                                { pod?.device?.serviceId || '-' }
                            </TableCell>
                            <TableCell sx={ { fontWeight: 500 } }>
                                { pod?.description }
                            </TableCell>
                            <TableCell>
                                { pod?.address }
                            </TableCell>
                            <TableCell align="center">
                                { pod?.locationType }
                            </TableCell>
                        </TableRow>
                    )) }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PodsList;